"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get toCamelCaseSchema () {
        return toCamelCaseSchema;
    },
    get toSnakeCaseSchema () {
        return toSnakeCaseSchema;
    }
});
const _lodash = require("lodash");
const _zod = require("zod");
// Helper to convert a ZodObject's shape to camelCase
const convertObjectToCamelCase = (schema)=>{
    const shape = schema.shape;
    const newShape = {};
    for(const key in shape){
        const camelKey = (0, _lodash.camelCase)(key);
        const value = shape[key];
        newShape[camelKey] = toCamelCaseSchema(value);
    }
    // @ts-expect-error - Prettify breaks ZodRawShape constraint but hover display works correctly
    return _zod.z.object(newShape);
};
function toCamelCaseSchema(schema) {
    if (schema instanceof _zod.ZodObject) {
        return convertObjectToCamelCase(schema);
    }
    if (schema instanceof _zod.ZodArray) {
        return _zod.z.array(toCamelCaseSchema(schema.element));
    }
    if (schema instanceof _zod.ZodUnion) {
        const options = schema.options;
        return _zod.z.union(options.map((opt)=>toCamelCaseSchema(opt)));
    }
    if (schema instanceof _zod.ZodDiscriminatedUnion) {
        const options = schema.options;
        const discriminator = schema._zod.disc;
        return _zod.z.discriminatedUnion((0, _lodash.camelCase)(discriminator), options.map((opt)=>toCamelCaseSchema(opt)));
    }
    if (schema instanceof _zod.ZodOptional) {
        return toCamelCaseSchema(schema.unwrap()).optional();
    }
    if (schema instanceof _zod.ZodNullable) {
        return toCamelCaseSchema(schema.unwrap()).nullable();
    }
    if (schema instanceof _zod.ZodDefault) {
        const def = schema._zod;
        return toCamelCaseSchema(def.def.innerType).default(def.def.defaultValue());
    }
    if (schema instanceof _zod.ZodIntersection) {
        const def = schema._zod;
        return _zod.z.intersection(toCamelCaseSchema(def.def.left), toCamelCaseSchema(def.def.right));
    }
    if (schema instanceof _zod.ZodTuple) {
        const def = schema._zod;
        return _zod.z.tuple(def.def.items.map((item)=>toCamelCaseSchema(item)));
    }
    if (schema instanceof _zod.ZodRecord) {
        const def = schema._zod;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _zod.z.record(def.def.keyType, toCamelCaseSchema(def.def.valueType));
    }
    return schema;
}
// Helper to convert a ZodObject's shape to snake_case
const convertObjectToSnakeCase = (schema)=>{
    const shape = schema.shape;
    const newShape = {};
    for(const key in shape){
        const snakeKey = (0, _lodash.snakeCase)(key);
        const value = shape[key];
        newShape[snakeKey] = toSnakeCaseSchema(value);
    }
    // @ts-expect-error - Prettify breaks ZodRawShape constraint but hover display works correctly
    return _zod.z.object(newShape);
};
function toSnakeCaseSchema(schema) {
    if (schema instanceof _zod.ZodObject) {
        return convertObjectToSnakeCase(schema);
    }
    if (schema instanceof _zod.ZodArray) {
        return _zod.z.array(toSnakeCaseSchema(schema.element));
    }
    if (schema instanceof _zod.ZodUnion) {
        const options = schema.options;
        return _zod.z.union(options.map((opt)=>toSnakeCaseSchema(opt)));
    }
    if (schema instanceof _zod.ZodDiscriminatedUnion) {
        const options = schema.options;
        const discriminator = schema._zod.disc;
        return _zod.z.discriminatedUnion((0, _lodash.snakeCase)(discriminator), options.map((opt)=>toSnakeCaseSchema(opt)));
    }
    if (schema instanceof _zod.ZodOptional) {
        return toSnakeCaseSchema(schema.unwrap()).optional();
    }
    if (schema instanceof _zod.ZodNullable) {
        return toSnakeCaseSchema(schema.unwrap()).nullable();
    }
    if (schema instanceof _zod.ZodDefault) {
        const def = schema._zod;
        return toSnakeCaseSchema(def.def.innerType).default(def.def.defaultValue());
    }
    if (schema instanceof _zod.ZodIntersection) {
        const def = schema._zod;
        return _zod.z.intersection(toSnakeCaseSchema(def.def.left), toSnakeCaseSchema(def.def.right));
    }
    if (schema instanceof _zod.ZodTuple) {
        const def = schema._zod;
        return _zod.z.tuple(def.def.items.map((item)=>toSnakeCaseSchema(item)));
    }
    if (schema instanceof _zod.ZodRecord) {
        const def = schema._zod;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _zod.z.record(def.def.keyType, toSnakeCaseSchema(def.def.valueType));
    }
    return schema;
}
